import { render, staticRenderFns } from "./ProvisionComponent.vue?vue&type=template&id=5c83fdf4&scoped=true&"
import script from "./ProvisionComponent.vue?vue&type=script&lang=js&"
export * from "./ProvisionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83fdf4",
  null
  
)

export default component.exports